import './frontendheader.css'
import logo from '../../img/logo.png'
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const FrontendHeader = () => {
    
    const [menuToogle, setMenuToogle] = useState(false);
    const isLoggedin = useSelector(state => state?.loginSlice?.isLoggedIn ? state.loginSlice?.isLoggedIn : false );
    const navigate = useNavigate();

    return (
        <>
            <div className='mainMenuWrapper-frontend'>
                <div className="headerMenu">
                    <ul className="menuLeft">
                        <li className="logo">
                            <img src={logo} className='logo_name' alt='Logo' onClick={() => navigate('/')} />
                        </li>
                    </ul>

                    <ul className='mobMenu'>
                        <li className='icons'>
                            <MenuIcon className={menuToogle===false? "displayBlock" : "displayNone" } onClick={()=>setMenuToogle(true)} />

                            <CloseIcon className={menuToogle? "displayBlock": "displayNone" } onClick={()=>setMenuToogle(false)} /> 
                        </li>
                    </ul>

                    <ul className={menuToogle===false? "menu" : "menuRight"}>
                        <li className="tabs" onClick={() => { navigate('/'); setMenuToogle(false) }}>  HOME </li>
                        <li className="tabs" onClick={() => { navigate('/projects'); setMenuToogle(false); }}> PROJECTS </li>
                        <li className="tabs" onClick={() => { navigate('/about'); setMenuToogle(false); }}> ABOUT US </li>
                        <li className="tabs" onClick={() => { navigate('/contact'); setMenuToogle(false); }}> CONTACTS</li>
                        {isLoggedin && <li className="tabs" onClick={() => { navigate('/dashboard'); setMenuToogle(false); }}> DASHBOARD</li>}
                        
                    </ul>
                </div>
            </div>
        </>
    )
}

export default FrontendHeader